module.exports = __webpack_public_path__ + "media/icons/app-icon@2x-43e4c13c.png";